export const isFiniteNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export const safeDiv = (numerator: number, denominator: number, fallback = 0): number =>
  isFiniteNumber(numerator) && isFiniteNumber(denominator) && denominator !== 0
    ? numerator / denominator
    : fallback;

export const sum = (values: readonly number[]): number =>
  values.reduce((total, value) => (isFiniteNumber(value) ? total + value : total), 0);

export const maxOr = (values: readonly number[], fallback: number): number => {
  const finite = values.filter(isFiniteNumber);
  return finite.length === 0 ? fallback : Math.max(...finite);
};

export const minOr = (values: readonly number[], fallback: number): number => {
  const finite = values.filter(isFiniteNumber);
  return finite.length === 0 ? fallback : Math.min(...finite);
};

export const clamp = (value: number, min: number, max: number, fallback = min): number =>
  isFiniteNumber(value) ? Math.min(max, Math.max(min, value)) : fallback;

export const roundTo = (value: number, digits = 1): number => {
  const factor = 10 ** digits;
  return Math.round(value * factor) / factor;
};

export const toFiniteNumber = (value: unknown): number | null => {
  if (isFiniteNumber(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};
